import { render, staticRenderFns } from "./index.vue?vue&type=template&id=041b732c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=041b732c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b732c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041b732c')) {
      api.createRecord('041b732c', component.options)
    } else {
      api.reload('041b732c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=041b732c&scoped=true", function () {
      api.rerender('041b732c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/globalMods/globalModNav/index.vue"
export default component.exports